export default {"src":"/_next/static/media/logo-with-dark-text.37f58985.svg","height":38,"width":218,"blurWidth":0,"blurHeight":0};